import styled from 'styled-components';

export const StyledShortcutKey = styled.span`
  text-decoration: underline;
  font-weight: bold;
`;
